export default "__VITE_ASSET__ac88d2ce__"